export class SecretRef {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsSecretsManagerRef",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpSecretManagerRef",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecretRef.attributeTypeMap;
    }
    constructor() {
    }
}
